import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useClients } from "@/lib/api";

/** Sentinel filter values — every other value is a client id as a string. */
export const CLIENT_FILTER_ALL = "all";
export const CLIENT_FILTER_UNASSIGNED = "unassigned";

interface ClientFilterSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/**
 * "Filter by client" dropdown — All / Unassigned / one entry per client.
 * Shared between the home project list and the admin projects table so both
 * filter the same way. Pair with `projectMatchesClientFilter` to apply it.
 */
export function ClientFilterSelect({ value, onChange, className }: ClientFilterSelectProps) {
  const { data: clients = [] } = useClients();

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className ?? "w-44"}>
        <SelectValue placeholder="All clients" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={CLIENT_FILTER_ALL}>All clients</SelectItem>
        <SelectItem value={CLIENT_FILTER_UNASSIGNED}>Unassigned</SelectItem>
        {clients.map((client) => (
          <SelectItem key={client.id} value={String(client.id)}>
            {client.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

/** Applies a `ClientFilterSelect` value against a project's `client_id`. */
export function projectMatchesClientFilter(
  project: { client_id?: number | null },
  filter: string,
): boolean {
  if (filter === CLIENT_FILTER_ALL) {
    return true;
  }
  if (filter === CLIENT_FILTER_UNASSIGNED) {
    return project.client_id == null;
  }
  return String(project.client_id) === filter;
}
